import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { forkJoin, EMPTY, Observable } from 'rxjs';
import { take, switchMap, share } from 'rxjs/operators';
import { CookieService } from '@ngx-toolkit/cookie';
import { CargoApiService } from 'app/api/cargoApi.service';
import { CienciaApiService } from 'app/api/cienciaApi.service';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { ServicoApiService } from 'app/api/servicoApi.service';
import {
  NewPerfil,
  Cargo,
  Ciencia
} from 'app/model/models';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';
import { SortingNumberDataTable } from 'app/shared/datatable/sorting-number-datatable';
import { SubSink } from 'subsink';
import Driver from 'driver.js';

@Component({
  selector: 'app-cargos-modelos-detalhes',
  templateUrl: './cargos-modelos-detalhes.component.html',
  styleUrls: ['./cargos-modelos-detalhes.component.css'],
  preserveWhitespaces: false
})
export class CargosModelosDetalhesComponent implements OnInit, OnDestroy {

  ciencias$: Observable<Ciencia[]>;
  cargoDetalhe: Cargo;;
  perfisAxiologia$: Observable<NewPerfil[]>;
  perfisComportamento$: Observable<NewPerfil[]>;
  perfisMotivadores$: Observable<NewPerfil[]>;
  idCliente: number;
  tituloCargo: string;
  idCargo: number;
  tipoCargo: string;
  idServico: number;
  qtdeUnidades: number;
  unidadesUtilizadas: number;
  unidadesRestantes: number;
  nomeServico: string;
  checkingWait = false;
  buttonWait = true;
  addWait: number;
  linkCopiado: boolean = false;

  filtroCiencias = [];
  tipoModal: string;

  usuarioLogado: string;
  order = 'fator';
  orderComportamento = 'fatorId';
  reverse = false;

  resizedCompetencias = false;
  resizedComportamento = false;
  resizedMotivadores = false;
  resizeModal = false;

  checkCookie = false;
  disableTour = false;
  driver = new Driver({
    className: 'tour-lucor',
    doneBtnText: 'Entendi', // Text on the final button
    closeBtnText: 'Fechar', // Text on the close button for this step
    nextBtnText: 'Próximo', // Next button text for this step
    prevBtnText: 'Anterior', // Previous button text for this step
  });

  dtOptions: DataTables.Settings = {};
  dtOptionsCompetencias: DataTables.Settings = {};


  /**
   * Imprimir relatório em PDF 
   */ 
  activePDF =  false;
  cutoffLimit = 60;

  @ViewChild('closeModalClone') closeModalClone: ElementRef;
  @ViewChild('closeModalSelecionado') closeModalSelecionado: ElementRef;

  /**
   * Gráficos
   */

  newArrayAxiologia: Array<any> = new Array<any>();
  newArrayComportamento: Array<any> = new Array<any>();
  newArrayMotivadores: Array<any> = new Array<any>();

  setChartLabelsAxiologia: Array<any> = new Array<any>();
  setChartDatasetsAxiologia: Array<any> = [];

   // Gráfico Padrão Perfil Competências
   public chartTypeCienciaAxiologia = 'radar';
   public chartDatasetsCienciaAxiologia = [{ data: [], label: 'Axiologia' }];
   public chartLabelsCienciaAxiologia: Array<any> = [];
   public chartColorsCienciaAxiologia: Array<any> = [
      {
        borderColor: 'rgba(145, 206, 244, 1)',
        backgroundColor: 'rgba(145, 206, 244, 0.5)',
        borderWidth: 2,
      }
   ];
   public chartOptionsCienciaAxiologia: any = {
     responsive: true,
     scale: {
       angleLines: {
           display: true
       },
       ticks: {
           suggestedMin: 0,
           suggestedMax: 100
       }
     }
   };

   // Gráfico Padrão Perfil Comportamento
   public chartTypeCienciaComportamento = 'radar';
   public chartDatasetsCienciaComportamento = [{ data: [], label: 'Comportamento Observado' }];
   public chartLabelsCienciaComportamento: Array<any> = [];
   public chartColorsCienciaComportamento: Array<any> = [
      {
        borderColor: 'rgba(145, 206, 244, 1)',
        backgroundColor: 'rgba(145, 206, 244, 0.5)',
        borderWidth: 2,
      }
   ];
   public chartOptionsCienciaComportamento: any = {
     responsive: true,
     scale: {
       angleLines: {
           display: true
       },
       /*
       gridLines: {
         color: ['#343A40', '#343A40', '#343A40', '#343A40', '#343A40', '#343A40', '#343A40', '#343A40', '#343A40', '#343A40']
       },
       */
       ticks: {
           fontSize: 10,
           suggestedMin: 0,
           suggestedMax: 100
       }
     }
   };

   // Gráfico Padrão Perfil Motivadores
   public chartTypeCienciaMotivadores = 'radar';
   public chartDatasetsCienciaMotivadores = [{ data: [], label: 'Motivadores' }];
   public chartLabelsCienciaMotivadores: Array<any> = [];
   public chartColorsCienciaMotivadores: Array<any> = [
      {
        borderColor: 'rgba(145, 206, 244, 1)',
        backgroundColor: 'rgba(145, 206, 244, 0.5)',
        borderWidth: 2,
      }
   ];
   public chartOptionsCienciaMotivadores: any = {
     responsive: true,
     scale: {
       angleLines: {
           display: true
       },
       ticks: {
           suggestedMin: 0,
           suggestedMax: 100
       }
     }
   };

  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }

  private subs = new SubSink();

  constructor(
    private cargosService: CargoApiService,
    private cienciasService: CienciaApiService,
    private servicosService: ServicoApiService,
    private alertService: AlertModalService,
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private sanitizer: DomSanitizer,
  ) { this.usuarioLogado = localStorage.getItem('userRole'); }

  ngOnInit() {
    SortingNumberDataTable.number_datatables.sortFunction();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      processing: true,
      responsive: true,
      order:[],
      columnDefs: [
        { type: 'natural', targets: [0, 2] },
        { type: 'html', targets: 1}
      ], 
      language: LanguageDataTable.portugues_datatables
    };

    this.dtOptionsCompetencias = {
      pagingType: 'numbers',
      pageLength: 40,
      processing: true,
      responsive: true,
      order:[0,"asc"],
      language: LanguageDataTable.portugues_datatables
    };
    
    this.goTop();
    this.getCiencias();

    this.cargoDetalhe = null;
    this.qtdeUnidades = null;

    this.subs.sink = this.route.data.subscribe(
      dados => {
        
        this.cargoDetalhe = dados.cargosResolver;
        this.idCargo = this.cargoDetalhe.id;
        this.tituloCargo = this.cargoDetalhe.titulo;
        this.idCliente = this.cargoDetalhe.pessoaJuridicaId;
        this.idServico = this.cargoDetalhe.servicoId;
        this.tipoCargo = this.cargoDetalhe.tipoCargo;
        this.qtdeUnidades = this.cargoDetalhe.qtdeUnidades;
        this.checkCookie = this.cookieService.hasItem('tourCargoDetalhes');

        if (this.idServico) {
          this.getServicoById(this.idServico);
        }

        forkJoin([
          this.perfisAxiologia$ = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, 1).pipe(share()),
          this.perfisComportamento$ = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, 2).pipe(share()),
          this.perfisMotivadores$ = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, 3).pipe(share()),
          ])
        .subscribe(resultado => {

          this.getPerfis(resultado[0], resultado[1], resultado[2]);
          this.buttonWait = false; // Habilita o botão Editar

        });

      });
  }


  getServicoById(id: number) {
    this.subs.sink = this.servicosService.v1ServicoServicoIdGet(id)
      .subscribe(servico => this.nomeServico = servico.tipoServico.nome);
  }


  startTour(): void {
    this.disableTour = true;
    // Define the steps for tour
    setTimeout(() => {
      this.driver.defineSteps([
        {
          element: '#one-element-tour',
          popover: {
            className: 'first-step-popover-class',
            title: 'Vamos fazer um tour?',
            description: 'Você pode usar as teclas <i class="fas fa-caret-left icon-tour"></i> e <i class="fas fa-caret-right icon-tour"></i> para avançar e voltar. Acesse aqui sempre que precisar.',
            position: 'left',
            closeBtnText: 'Eu vejo depois.',
            nextBtnText: 'Vamos lá!',
            prevBtnText: '<i class="fas fa-plane-departure"></i>'
          }
        },
        {
          element: '#two-element-tour',
          popover: {
            title: 'Botão "Editar"',
            description: 'Aqui você pode editar o cargo. É possível alterar todos os dados, inclusive associar outra avaliação e alterar o perfil comportamental por ciência.',
            position: 'left'
          }
        },
        {
          element: '#three-element-tour',
          popover: {
            title: 'Botão "Clonar Cargo"',
            description: 'Você pode criar um novo cargo ou novo modelo a partir deste. É possível clonar totalmente ou escolher os itens que irá clonar.',
            position: 'left'
          }
        },
        {
          element: '#four-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Botão Excluir',
            description: 'Aqui você exclui o cargo. Use com cuidado!',
            position: 'left'
          }
        },
        {
          element: '#five-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Menu em abas',
            description: 'Clique sobre o item para visualizar os dados.',
            position: 'bottom'
          }
        },
        {
          element: '#six-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Adequeção com pessoas',
            description: 'Nesta aba é exibido o Ranking de adequação e compatibilidade com o cargo.',
            position: 'bottom'
          }
        },
        {
          element: '#seven-element-tour-0',
          stageBackground: '#7a7a7a',
          popover: {
            title: 'Visão do Grupo',
            description: 'Dados gerais de adequação do Grupo em relação ao Cargo.',
            position: 'right'
          }
        },
        {
          element: '#seven-element-tour-1',
          stageBackground: '#7a7a7a',
          popover: {
            title: 'Necessidades de Treinamento',
            description: 'Dados que darão base para o desenvolvimento de cada pessoa, com base no perfil do cargo.',
            position: 'right'
          }
        },
        {
          element: '#seven-element-tour-2',
          stageBackground: '#7a7a7a',
          popover: {
            title: 'Relatório em PDF',
            description: 'Baixe o relatório em PDF com a análise de adequação do grupo, com base no perfil do cargo. Você pode definir um valor mínimo para corte, onde apenas os avaliados com a porcentagem a partir deste valor serão listados no relatório (o valor padrão é 60).',
            position: 'right'
          }
        },
        {
          element: '#seven-element-tour',
          stageBackground: '#7a7a7a',
          popover: {
            title: 'Baixar Planilha',
            description: 'Você pode baixar os dados em uma planilha de Excel.',
            position: 'right'
          }
        },
        {
          element: '#nine-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Posição no Ranking',
            description: 'Esta é a posição da pessoa no Ranking de adequação.',
            position: 'right'
          }
        },
        {
          element: '#ten-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Nome do avaliado',
            description: 'Este é nome do avaliado. Você pode clicar sobre ele para ver o perfil completo da pessoa.',
            position: 'right'
          }
        },
        {
          element: '#eleven-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Porcentagem de Adequação',
            description: 'Esta é a porcentagem de adequação do avaliado com o cargo.',
            position: 'left'
          }
        },
        {
          element: '#twelve-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Botão "Compatibilidade"',
            description: 'Clique aqui para visualizar os gráficos de compatibilidade do perfil do avaliado em relação aos perfis de cada ciência.',
            position: 'left'
          }
        },
        {
          element: '#eleven-element-tour-0',
          stageBackground: '#343a40',
          popover: {
            title: 'FeedBack',
            description: 'Informações sobre a pessoa em relação ao cargo e seu estado atual.',
            position: 'left'
          }
        },
        {
          element: '#eleven-element-tour-1',
          stageBackground: '#343a40',
          popover: {
            title: 'Botão "Relatório"',
            description: 'Aqui você poderá visualizar o Relatório Comportamental do avaliado, caso esteja disponível.',
            position: 'left'
          }
        },
        {
          element: '#eleven-element-tour-2',
          stageBackground: '#343a40',
          popover: {
            title: 'Botão "Currículo"',
            description: 'Aqui você poderá visualizar o currículo do avaliado, caso esteja disponível.',
            position: 'left'
          }
        },
        {
          element: '#thirteen-element-tour',
          stageBackground: '#343a40',
          popover: {
            title: 'Botão "Selecionado"',
            description: 'Clique no ícone para Adicionar ou remover essa pessoa aos selecionados. No menu, você encontra o item "Selecionados", onde poderá editar, excluir ou criar novas listas.',
            position: 'left'
          }
        }
      ]);
      // Start the introduction
      this.driver.start();
      this.disableTour = false;
    }, 1000);
  }

  redirectTo(uri:string){
    this.router.navigateByUrl('cargos-modelo', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
 }

  

  onDelete(cargo: Cargo) {
    const result$ = this.alertService.showConfirm('Confirmação', 'Tem certeza que deseja excluir esse cargo?');
    result$.asObservable()
    .pipe(
      take(1),
      switchMap(result => result ? this.cargosService.v1CargoCargoIdDelete(cargo.id) : EMPTY)
    )
    .subscribe(
      success => {
        this.alertService.showAlertSuccess('Cargo Modelo enviado para a Lixeira!');
        this.router.navigate(['/cargos-modelo']);
      },
      error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao excluir Cargo Modelo. Tente novamente mais tarde.');
        }
      }
    );
  }

  customComparator(itemA, itemB) { // Adicionado para customizar a função 'comparator' do OrderBy
    const hasNumber = /\d/;
    const verificaTipo = hasNumber.test(itemA); // Verifica se a variável contém número
    if (verificaTipo === true) {
      return  itemA - itemB; // Corrige a situação que retorna algo assim: [1, 10, 12, 15, 5, 8, 9]
    } else {
      return itemA.localeCompare(itemB); // Corrige a situação da palavra acentuada ficar por último na lista
    }
  }

  goBack(): void {
    this.location.back();
  }

  modalClone() {
    setTimeout(() => {
      this.closeModalClone.nativeElement.click(); // fechar modal
    }, 500);
  }

  updateLista(data: { id?: number; tipoCargo?: string }) {
    const modalBack = document.getElementsByClassName('modal-backdrop')[0];
    if (modalBack) { modalBack.remove(); }
    if (data && data.id) {
      if (data.tipoCargo && data.tipoCargo === 'Normal') {
        this.redirectTo('/cargos/' + data.id);
      } else {
        this.redirectTo('/cargos-modelo/' + data.id);
      }
    }
  }

  cancelModal() {
    this.checkingWait = false;
    this.addWait = null;
  }

  modalResize() {
    this.resizeModal = !this.resizeModal;
  }


  copyInputMessage(inputElement){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.linkCopiado = true;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    $.fn['dataTable'].ext.oSort;
  }

  private setCookie() {
    this.cookieService.setItem( 'tourCargoDetalhes', '1' );
  }

  private getCiencias() {
    this.ciencias$ = this.cienciasService.v1CienciaGet();
  }


  private getPerfis(perfisAxiologia, perfisComportamento, perfisMotivadores) {

    if (this.checkCookie === false) {
      this.startTour();
      this.setCookie();
    }

    const padraoAxiologiaLabel = [];
    const padraoComportamentoLabel = [];
    const padraoMotivadoresLabel = [];
    const padraoAxiologiaValue = [];
    const padraoComportamentoValue = [];
    const padraoMotivadoresValue = [];

    const resultAxiologia = [];
    const resultComportamento = [];
    const resultMotivadores = [];

    const matchAxiologia: NewPerfil[] = [];
    const matchComportamento: NewPerfil[] = [];
    const matchMotivadores: NewPerfil[] = [];

    perfisAxiologia.map(fatoresAxiologia => {
            if (fatoresAxiologia.fator !== null) {
               padraoAxiologiaLabel.push(fatoresAxiologia.fator);
               padraoAxiologiaValue.push(fatoresAxiologia.ideal);
               resultAxiologia.push(fatoresAxiologia.fator);
               matchAxiologia.push(fatoresAxiologia);
            }
      });

    perfisComportamento.map(fatoresComportamento => {
            if (fatoresComportamento.fator !== null) {

               switch (fatoresComportamento.fator) {
                case 'DISC NATURAL - Dominância':
                  padraoComportamentoLabel.push('Dominância');
                break;
    
                case 'DISC NATURAL - Influência':
                  padraoComportamentoLabel.push('Influência');
                break;
    
                case 'DISC NATURAL - Estabilidade':
                  padraoComportamentoLabel.push('Estabilidade');
                break;
    
                case 'DISC NATURAL - Cautela':
                  padraoComportamentoLabel.push('Cautela');
                break;
    
                case 'DISC ADAPTÁVEL - Dominância':
                  padraoComportamentoLabel.push('Dominância (A)');
                break;
    
                case 'DISC ADAPTÁVEL - Influência':
                  padraoComportamentoLabel.push('Influência (A)');
                break;
    
                case 'DISC ADAPTÁVEL - Estabilidade':
                  padraoComportamentoLabel.push('Estabilidade (A)');
                break;
    
                case 'DISC ADAPTÁVEL - Cautela':
                  padraoComportamentoLabel.push('Cautela (A)');
                break;
              }

               padraoComportamentoValue.push(fatoresComportamento.ideal);
               resultComportamento.push(fatoresComportamento.fator);
               matchComportamento.push(fatoresComportamento);
            }
      });

    perfisMotivadores.map(fatoresMotivadores => {
            if (fatoresMotivadores.fator !== null) {
               padraoMotivadoresLabel.push(fatoresMotivadores.fator);
               padraoMotivadoresValue.push(fatoresMotivadores.ideal);
               resultMotivadores.push(fatoresMotivadores.fator);
               matchMotivadores.push(fatoresMotivadores);
            }
      });
      
    this.getGraficosPadroesCiencias(
          padraoAxiologiaValue, padraoAxiologiaLabel,
          padraoComportamentoValue, padraoComportamentoLabel,
          padraoMotivadoresValue, padraoMotivadoresLabel
      );

  }


  private getGraficosPadroesCiencias(

    padraoAxiologiaValue: Array<number> = [],
    padraoAxiologiaLabel: Array<string> = [],
    padraoComportamentoValue: Array<number> = [],
    padraoComportamentoLabel: Array<string> = [],
    padraoMotivadoresValue: Array<number> = [],
    padraoMotivadoresLabel: Array<string> = []) {

    this.chartLabelsCienciaAxiologia = padraoAxiologiaLabel;
    this.chartDatasetsCienciaAxiologia = [{ data: padraoAxiologiaValue, label: 'Axiologia' }];

    this.chartLabelsCienciaComportamento = padraoComportamentoLabel;
    this.chartDatasetsCienciaComportamento = [{ data: padraoComportamentoValue, label: 'Comportamento Observado' }];

    this.chartLabelsCienciaMotivadores = padraoMotivadoresLabel;
    this.chartDatasetsCienciaMotivadores = [{ data: padraoMotivadoresValue, label: 'Motivadores' }];

  }

  
  private goTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
